var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__inner",class:_vm.showOverflow && _vm.overflowing ? 'progress-bar__inner--overflow' : '',style:({
      width: `${_vm.constrainedValue}%`,
      'transition-duration': [100, 0].includes(_vm.constrainedValue)
        ? '0s'
        : '1s',
    })}),_vm._v(" "),_c('span',{staticClass:"progress-bar__status-text"},[(_vm.showValue)?[_vm._v(_vm._s(`${_vm.displayValue}%`))]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.status)+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }